import { cn } from "@/lib/utils"

const LABELS: Record<string, string> = {
  new: "Neu", reviewed: "Gesichtet", done: "Erledigt", missed: "Verpasst",
  answered: "Angenommen", ringing: "Klingelt", booked: "Gebucht",
  no_booking: "Keine Buchung", open: "Offen",
  high: "Hoch", medium: "Mittel", low: "Niedrig", critical: "Kritisch",
}

/** Portal-Badge — nutzt .pp-badge-{status} exakt wie altes Portal. */
export function StatusBadge({
  status, label, className,
}: {
  status?: string | null
  label?: string
  className?: string
}) {
  const key = (status || "").toLowerCase()
  const text = label ?? LABELS[key] ?? status ?? "—"
  return (
    <span className={cn("pp-badge", key && `pp-badge-${key}`, className)}>
      {text}
    </span>
  )
}
